import { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { LogOut, Bell } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { Logo } from "../../components/Logo";
import { useNotifications } from "../../components/crm";
import { formatDistanceToNow } from "date-fns";

export default function ClientLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [bellOpen, setBellOpen] = useState(false);
  const { items, unread, markAll } = useNotifications();

  return (
    <div className="min-h-screen bg-[#FAFAFC]">
      <header className="h-16 bg-white border-b border-border sticky top-0 z-30">
        <div className="max-w-6xl mx-auto h-full px-5 flex items-center justify-between">
          <Logo to="/client" />
          <div className="flex items-center gap-3">
            <button onClick={() => navigate("/contact")} className="text-sm font-semibold bg-brand-orange text-white px-3 py-1.5 rounded-lg hidden sm:block" data-testid="book-next-project">Book your next project</button>
            <div className="relative">
              <button onClick={() => setBellOpen((v) => !v)} className="relative p-2 rounded-lg hover:bg-brand-light text-brand-purpleDeep" data-testid="client-notif-bell">
                <Bell size={20} />
                {unread > 0 && <span className="absolute top-1 right-1 w-4 h-4 rounded-full bg-brand-orange text-white text-[10px] flex items-center justify-center">{unread}</span>}
              </button>
              {bellOpen && (
                <div className="absolute right-0 mt-2 w-80 bg-white rounded-xl shadow-2xl border border-border overflow-hidden z-50">
                  <div className="flex items-center justify-between px-4 py-3 border-b border-border">
                    <span className="font-heading font-bold text-sm text-brand-purpleDeep">Notifications</span>
                    <button onClick={markAll} className="text-xs text-brand-purple font-medium">Mark all read</button>
                  </div>
                  <div className="max-h-96 overflow-y-auto">
                    {items.length === 0 && <div className="p-6 text-center text-sm text-brand-purpleDeep/40">No notifications</div>}
                    {items.map((n) => (
                      <div key={n.id} className={`px-4 py-3 border-b border-border last:border-0 ${!n.read ? "bg-brand-light/40" : ""}`}>
                        <div className="text-sm font-medium text-brand-purpleDeep">{n.title}</div>
                        {n.body && <div className="text-xs text-brand-purpleDeep/50 mt-0.5">{n.body}</div>}
                        <div className="text-[11px] text-brand-purpleDeep/40 mt-1">{n.created_at ? formatDistanceToNow(new Date(n.created_at), { addSuffix: true }) : ""}</div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
            <span className="text-sm text-brand-purpleDeep/60 hidden sm:block">{user?.name}</span>
            <button onClick={() => navigate("/client/profile")} className="text-sm font-semibold text-brand-purple hover:text-brand-purpleDark hidden sm:block" data-testid="client-profile-link">My Profile</button>
            <button onClick={() => { logout(); navigate("/login"); }} className="p-2 rounded-lg hover:bg-brand-light text-brand-purpleDeep" data-testid="client-logout"><LogOut size={18} /></button>
          </div>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-5 py-8"><Outlet /></main>
    </div>
  );
}
